import { render, staticRenderFns } from "./ControlDoctors.vue?vue&type=template&id=21c4f0d5&scoped=true"
import script from "./ControlDoctors.vue?vue&type=script&lang=js"
export * from "./ControlDoctors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c4f0d5",
  null
  
)

export default component.exports